"use client"

import { useMemo } from "react"
import { NpFeatureCarouselSection } from "src/components/np-design/sections/features/NpFeatureCarouselSection"
import { CarouselSlideData } from "src/data/product-details/types"
import { SanitySectionProps } from "src/data/sanity/types"

export type SanityCarouselSectionProps = Partial<SanitySectionProps<"carousel">>

export const SanityCarouselSection = ({ heading, slides }: SanityCarouselSectionProps) => {
  const mappedSlides = useMemo(() => {
    return slides?.flatMap<CarouselSlideData>((slide) => {
      if (!slide.image) {
        return []
      }
      return {
        src: slide.image,
        captionPrimary: slide.captionPrimary || undefined,
        captionSecondary: slide.captionSecondary || undefined,
      }
    })
  }, [slides])

  if (!mappedSlides?.length) {
    return null
  }

  return <NpFeatureCarouselSection heading={heading || undefined} slides={mappedSlides} />
}
